import { render } from "./OcrVerificationFormLoading.vue?vue&type=template&id=b0341f58&scoped=true"
const script = {}

import "./OcrVerificationFormLoading.vue?vue&type=style&index=0&id=b0341f58&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0341f58"]])

export default __exports__